module.exports = __webpack_public_path__ + "img/thumbnail_SpectacledFlyingFox_u_normal.efc1629d.png";